import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { pipe } from 'rxjs';

import { PipelineService } from '@app/core/pipelines/services/pipeline.service';
import { ProductDesignService } from '@app/core/quotes/services/product-design.service';
@Component({
  selector: 'cnc-nd-attachment-popup',
  templateUrl: './nd-attachment-popup.component.html',
  styleUrls: ['./nd-attachment-popup.component.scss'],
})
export class NdAttachmentPopupComponent implements OnInit {
  pageTitle :string = 'View Attachment';
  loading :boolean;

  validFile :boolean;

  valid_format :any[] = [
    'jpeg',
    'jpg',
    'png',
    'bmp',
    'ico',
    'icon',
    'gif',
    'svg',
    'txt',
    'doc',
    'docx',
    'xls',
    'xlsx',
    'ppt',
    'pptx',
    'pdf',
  ];

  @Input() attachment :any;

  constructor(
    public activeModal :NgbActiveModal,
    public pipelineSvc :PipelineService,
    private designSvc :ProductDesignService,
    private toastr :ToastrService,
  ) {}

  ngOnInit() {
    const file_name_string = this.attachment.name;
    const file_name_array = file_name_string.split('.');
    const file_extension = file_name_array[file_name_array.length - 1];

    if (this.valid_format.indexOf(file_extension.toLowerCase()) == -1) {
      this.validFile = false;
    } else {
      this.validFile = true;
    }
  }

  viewAttachment(attachment :any) {
    this.attachment = attachment;
  }
}
